import {SbIcon} from '@ngx-seatback/icons'
import {AttachmentDTO, AttachmentType} from '../../services/api/api';
import {FileDummies, FileDummyTypes} from './file-dummy.model';

export interface FileDummyItem {
  color: string;
  fileName: string;
  icon: SbIcon;
}

interface ColorSet {
  baseColor: string;
  fillColor: string;
  gradientColor: string;
}


export class FileDummy {
  colorSet: ColorSet;
  fileName: string;
  icon: SbIcon;

  constructor(dto: any) {
    if (dto) {
      switch (true) {
        case (dto._type === 'AttachmentDTO'):
          if (dto.attachmentType === AttachmentType.LINK) {
            if (dto.link) {
              this.findKeysInFileDummyTypes(dto.link.toString()).then((res) => {
                if (!res) {
                  this.buildFileDummyItem(FileDummies.get(dto.attachmentType));
                }
              });
            } else {
              this.buildFileDummyItem(FileDummies.get(dto.attachmentType));
            }
          }
          if (dto.attachmentType === AttachmentType.UPLOAD) {
            if (dto.fileName) {
              this.findKeysInFileDummyTypes(dto.fileName.toString()).then((res) => {
                if (!res) {
                  this.buildFileDummyItem(FileDummies.get('UNKNOWN'));
                }
              });
            } else {
              this.buildFileDummyItem(FileDummies.get('UNKNOWN'));
            }
          }
          break;
        case (dto._type === 'MediumDTO'):
          if (dto.fileName) {
            this.findKeysInFileDummyTypes(dto.fileName.toString()).then((res) => {
              if (!res) {
                this.buildFileDummyItem(FileDummies.get('UNKNOWN'));
              }
            });
          } else {
            this.buildFileDummyItem(FileDummies.get('UNKNOWN'));
          }
          break;
      }
    }
  }

  findKeysInFileDummyTypes(searchStr: string): Promise<boolean> {
    return new Promise((res) => {
      const str = searchStr.split('.');
      for (const s of str) {
        if (FileDummyTypes.has(s.toLowerCase())) {
          this.buildFileDummyItem(FileDummies.get(FileDummyTypes.get(s.toLowerCase())));
          res(true);
        }
      }
      res(false);
    });
  }

  buildFileDummyItem(fileDummyItem: FileDummyItem) {
    if (fileDummyItem) {
      this.colorSet = this.generateColorSet(fileDummyItem.color);
      this.fileName = fileDummyItem.fileName;
      this.icon = fileDummyItem.icon;
      return;
    }
  }

  generateColorSet(color: string): ColorSet {
    return {
      baseColor: color,
      gradientColor: this.adjustColor(color, -18),
      fillColor: this.adjustColor(color, -50),
    };
  }

  adjustColor(color: string, percent: number) {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = parseInt(String(R * (100 + percent) / 100), 0);
    G = parseInt((String(G * (100 + percent) / 100)), 0);
    B = parseInt((String(B * (100 + percent) / 100)), 0);

    R = (R < 255) ? R : 255;
    G = (G < 255) ? G : 255;
    B = (B < 255) ? B : 255;

    const RR = ((R.toString(16).length === 1) ? '0' + R.toString(16) : R.toString(16));
    const GG = ((G.toString(16).length === 1) ? '0' + G.toString(16) : G.toString(16));
    const BB = ((B.toString(16).length === 1) ? '0' + B.toString(16) : B.toString(16));

    return '#' + RR + GG + BB;
  }


}



